<template>
  <b-container>
    <p class="text-center font-italic font-small" v-html="disclaimer" />
    <b-row align-h="around" class="my-4">
      <b-col cols="auto">
        <b-button variant="outline-dark"
          @click="backAction"
        >
          Back
        </b-button>
      </b-col>
      <b-col cols="auto">
        <b-button variant="outline-primary"
          :disabled="!canProceed"
          @click="nextAction"
        >
          Next
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';
import { oneLineTrim } from 'common-tags';
import { WAIVER_DISCLAIMER } from '@/store/state';
import { emailRegex } from '@/utils';

export default {
  props: {
    next: {
      type: [Object, Function]
    },
    back: {
      type: Object
    },
    canProceed: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    ...mapState([
      WAIVER_DISCLAIMER,
    ]),
    disclaimer () {
      return oneLineTrim`${
        this[WAIVER_DISCLAIMER].split(' ').map(word => emailRegex.test(word) ? `<a href='mailto:${ word }'>${ word }</a>` : word).join(' ')
      }`
    },
  },
  methods: {
    backAction () {
      this.$router.back()
    },
    nextAction () {
      if (typeof this.next === 'function') this.next();
      else this.$router.push(this.next);
    },
  }
}
</script>

<style scoped>

</style>